import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment'
import SelectForm from './../components/Complements/SelectForm';
//import Title from './../components/Complements/Title';
import DateFnsUtils from '@date-io/date-fns';
import "moment/locale/es";
import esLocale from "date-fns/locale/es";
import { connect } from 'react-redux';
import { getCodes } from "./../actions/codes";
import Button from '@material-ui/core/Button';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { Grid, CircularProgress, Icon, Fab } from '@material-ui/core';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import Typography from '@material-ui/core/Typography';
import './../components/Codes/style/tableresponsive.css';
import Pagination from '@material-ui/lab/Pagination';
import Alert from '@material-ui/lab/Alert';
import Dashboard from '../components/Menu/Dashboard';
import { history } from '../helpers/history';
import { makeStyles } from '@material-ui/core/styles';
import { sendMobile } from '../functions/mobile';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import Footer from '../components/Complements/Footer';
//import { myBase64Image } from './../constants/logo-excel';
import { exportExcel } from './../functions/exportExcel';
import { filterArrayEqual } from '../functions/arrays';
// import Title from '../components/Complements/Title';
import { IconButton } from '@mui/material';
import { ArrowBackIos } from '@mui/icons-material';
import ModalTableReportDetails from '../components/Transfers/ModalTableReportDetails';


//const ExcelJS = require('exceljs');
moment.locale("en");

const useStyles = makeStyles(theme => ({
    valuepositive: {
        color: '#B48518'
    },
    valuenegative: {
        color: '#dc3545'
    },
    textAll: {
        borderRadius: '8px 8px 0px 0px',
        [theme.breakpoints.up('xs')]: {
            backgroundColor: '#0073D2',
            backgroundSize: '100% 100%',

        },
        [theme.breakpoints.up('sm')]: {
            backgroundColor: '#0073D2',
            backgroundSize: '100% 100%',

        },
        [theme.breakpoints.up('md')]: {
            backgroundColor: '#0073D2',
            backgroundSize: '100% 100%',

        },
        [theme.breakpoints.up('lg')]: {
            backgroundColor: '#0073D2',
            backgroundSize: '100% 100%',

        },
        [theme.breakpoints.up('xl')]: {
            backgroundColor: '#0073D2',
            backgroundSize: '100% 100%',
        }

    },
    divStandard: {
        padding: "20px",
        backgroundColor: theme.palette.type === 'dark' ? '#4a4a4a' : '#fafafa',
        borderRadius: "16px",
    }
}));

const MovementsContainer = props => {

    const classesdefault = useStyles();
    const { classes, secuencial, parameters } = props;
    const monthLenght = filterArrayEqual(parameters, "code", "PERIOD_MAXIMUMS_OF_MOVEMENT_OF_CONSULT")[0]
    // console.log(monthLenght);
    const [codespaginate, setCodesPaginate] = useState([])
    const [codes, setCodes] = useState([])
    const [page, setPage] = useState(1)
    const [count, setCount] = useState(1)
    // const [ secuencialAccount, setSecuencialAccount ] = useState(secuencial)
    const [loading, setLoading] = useState(false)
    const [dateStart, setDateStart] = useState(new Date())
    //const [dateEnd, setDateEnd] = useState(new Date())
    const dateEnd = new Date()
    const [dateEndRange, setDateEndRange] = useState(dateEnd)
    const [dateValue, setDateValue] = useState(JSON.stringify({ month: moment().month(), year: moment().year() }))
    const [openModal, setOpenModal] = useState(false)
    const [details, setDetails] = useState([])


    const mount = () => {
        const unmount = () => {
            moment.locale('es-es')
            // console.log('match', secuencial)

            handleGetDataMovementsBySecuencialAccount(dateStart, dateEndRange, secuencial)

        }
        return unmount()
    }

    useEffect(mount, [])

    const loadAllMovements = () => {
        setLoading(true); // Puedes mostrar un indicador de carga mientras se cargan todos los datos
        handleGetDataMovementsBySecuencialAccount(dateStart, dateEndRange, secuencial);
    };

    const handleGetDataMovementsBySecuencialAccount = (valueDateStart, valueDateEnd, secuencial) => {

        setLoading(true)

        getCodes(valueDateStart, valueDateEnd, secuencial).payload.then(response => {
            // console.log('MovementsContainer', response.data.movements)

            response.data.movements.sort(function (x, y) {

                let a = new Date(x.fechaMaquina),
                    b = new Date(y.fechaMaquina);
                return b - a;

            })

            const newData = response.data.movements.map(function (item) {
                return {
                    ...item,
                    fecha: moment(item.MovDate).format('YYYY-MM-DD'),
                    tipoMovimiento: (item.MovTypeId === "1" && item.isDebit === "FALSE") ? "Crédito" : (item.MovTypeId === "1" && item.isDebit === "TRUE") ? "Débito" : (item.MovTypeId === "2") ? "Crédito" : (item.MovTypeId === "3") ? "Débito" : "Balance"
                }
            })
            //console.log(newData);
            setCodes(newData);
            getDataViewTable(newData)
            setLoading(false)

        }).catch(error => {

            setLoading(false)
            setCodes([]);
            getDataViewTable([])

            //console.log(error);
        })
    }

    const handleDateStart = (date) => {
        setDateStart(date)
    }

    const handleDateEnd = (date) => {
        setDateEndRange(date)
    }

    const onChangePaginationCodes = (e, page) => {
        //console.log(page)//4
        //console.log(codes)//16
        let init = (page - 1) * 5;//15
        let end = page * 5;//20
        let datacodespaginate = [];
        datacodespaginate = codes.slice(init, end);
        //console.log(datacodespaginate)
        setCodesPaginate(datacodespaginate)
        setPage(page)
    }


    const getDataViewTable = (allData) => {
        let datacodespaginate = [];
        let count = parseInt((allData.length / 5).toString());
        let residuo = allData.length % 5;

        if (residuo > 0) {
            count++;
        }

        if (allData.length > 0) {
            datacodespaginate = allData.slice(0, 5);
        }
        setCodesPaginate(datacodespaginate)
        setCount(count)
        setPage(1)
    }

    //handle
    const handleSelectCode = (val) => {
        //console.log('handleSelectCode - val',val)
        setDateValue(val)
        setLoading(true)
        if (val === 'Todos los movimientos') {
            let valueStart = moment().subtract("M", monthLenght.value);
            setDateStart(valueStart)
            setDateEndRange(new Date())
            handleGetDataMovementsBySecuencialAccount(valueStart, new Date(), secuencial)
            setDateValue(JSON.stringify({ month: moment().month(), year: moment().year() }))
        } else {
            let obj = JSON.parse(val)
            // console.log('busca mes:', obj.month)

            let selectMonth = new Date(obj.year, obj.month, 1)
            setDateStart(moment(selectMonth).startOf('month'))
            setDateEndRange(new Date())
            let valueStart = moment(selectMonth).startOf('month');
            let valueEnd = moment(selectMonth).endOf('month');
            handleGetDataMovementsBySecuencialAccount(valueStart, valueEnd, secuencial)
            setDateValue(val)
            //setLoading(false)
            // getDataViewTable(props.codes)
        }

    }

    const handleFindRange = () => {

        //setLoading(true)
        handleGetDataMovementsBySecuencialAccount(dateStart, dateEndRange, secuencial)

    }


    const excel = async () => {
        //console log de codes
        // console.log('Movements Container - Excel codes: ', codes)
        let headers = ['Fecha',
            '# Documento',
            'Transacción',
            'Concepto',
            'Tipo',
            'Valor',
            'Saldo']
        let docName = "Movimientos de Cuenta"
        let columnNames = ["fecha", "MovId", "TypeDesc", "Description", "tipoMovimiento", "Amount", "Balance"]
        let docType = 1
        await exportExcel(headers, codes, docName, columnNames, docType)
    }

    const handleCloseDialog = () => {
        setOpenModal(false)
    }

    const handleViewTableDetails = (item) => {
        setDetails(item)
        setOpenModal(true)
    }

    const filterMovementsByType = (type) => {
        if (type === 'debito') {
            const debitMovements = codes.filter(movement => movement.tipoMovimiento === 'Débito');
            setCodesPaginate(debitMovements);
        } else if (type === 'credito') {
            const creditMovements = codes.filter(movement => movement.tipoMovimiento === 'Crédito');
            setCodesPaginate(creditMovements);
        }
    };

    const renderAllMovementsButton = () => {
        return (
            <Button variant="outlined" style={{ width: 'auto' }} onClick={loadAllMovements}>Todos los Movimientos</Button>
        );
    };

    const renderTableMovements = () => {
        if (loading) {
            return <CircularProgress />;
        } else {
            if (codespaginate.length > 0) {
                return (
                    <div className={"container"}>
                        <Grid container justifyContent='space-between'>
                            <Grid item>

                                {localStorage.caja_app !== undefined ?
                                    <Button
                                        color='primary'
                                        variant='contained'
                                        style={{ width: 'auto' }}
                                        onClick={() => {
                                            let send = {
                                                type: 'action',
                                                action: 'export_movements_excel',
                                                data: `{"dateStart":"${moment(dateStart).format('YYYY-MM-DD')}","dateEnd": "${moment(dateEnd).format('YYYY-MM-DD')}", "secuencial":"${secuencial}"}`
                                            };
                                            sendMobile(JSON.stringify(send));
                                        }}
                                    >
                                        EXPORTAR EN EXCEL
                                    </Button>
                                 :
                                    <Button
                                        color='primary'
                                        variant='contained'
                                        style={{ width: 'auto' }}
                                        startIcon={<Icon>attach_file</Icon>}
                                        onClick={() => excel()}
                                    >
                                        DESCARGAR EN EXCEL
                                    </Button>
                                }
                            </Grid>

                            <Grid container spacing={2} style={{ width: 'auto' }}>
                                    <Grid item>
                                    {renderAllMovementsButton()}
                                </Grid>
                                <Grid item>
                                    <Button variant="outlined" onClick={() => filterMovementsByType('debito')}>Débito</Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="outlined" onClick={() => filterMovementsByType('credito')}>Crédito</Button>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} style={{ overflowX: 'auto' }}>
                            <Table>
                                <Thead style={{ alignItems: 'center' }}>
                                    <Tr>
                                        <Th className="colunmvalue" style={{ textAlign: 'center' }}>Fecha</Th>
                                        <Th className="colunmvalue" style={{ textAlign: 'center' }}># Documento</Th>
                                        <Th className="colunmvalue" style={{ textAlign: 'center' }}>Valor</Th>
                                        <Th className="colunmvalue" style={{ textAlign: 'center' }}>Saldo</Th>
                                        <Th style={{ textAlign: 'center' }}>Detalles</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {codespaginate.map((row, index) => (
                                        <Tr key={index}>
                                            <Td style={{ textAlign: 'center' }}>{row.fecha}</Td>
                                            <Td style={{ textAlign: 'center' }}>{row.MovId}</Td>
                                            <Td style={{ textAlign: 'center' }} className={(row.isDebit === 'FALSE') ? classesdefault.valuepositive : classesdefault.valuenegative}>
                                                $ {(row.isDebit === 'TRUE') ? "-" + row.Amount : row.Amount}
                                            </Td>
                                            <Td style={{ textAlign: 'center' }}>$ {row.Balance}</Td>
                                            <Td style={{ textAlign: 'center' }}>
                                                <Button
                                                    variant="outlined"
                                                    color="secondary"
                                                    size="small"
                                                    onClick={() => handleViewTableDetails(row)}
                                                >
                                                    VER DETALLES
                                                </Button>
                                            </Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </Grid>
                        <Grid item xs={12}>
                            <Pagination
                                style={{ marginTop: '5px' }}
                                count={count}
                                page={page}
                                onChange={onChangePaginationCodes}
                            />
                        </Grid>

                    </div>
                );
            } else {
                return <Alert severity="info">No se han encontrado movimientos en el mes seleccionado.</Alert>;
            }
        }
    };


    const renderBody = () => {
        return (
            <div className={classesdefault.divStandard}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography>
                            <IconButton onClick={() => history.push("/")} style={{ marginRight: "8px" }}>
                                <ArrowBackIos />
                            </IconButton>
                            Movimientos de cuenta
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography
                            component="h2"
                            variant="h6"
                            gutterBottom
                        >
                            Detalle de movimientos de la Cuenta
                        </Typography>
                    </Grid>
                </Grid>
                <SelectForm
                    name="Período"
                    label="Seleccionar período"
                    classes={classes}
                    dateValue={dateValue}
                    onSelected={(val) => handleSelectCode(val)}
                    parameters={parameters}
                />
                <br />
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Grid container justify="center" spacing={3} alignItems="flex-end">
                            <Grid item md={4} sm={12} xs={12}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                    <KeyboardDatePicker
                                        minDate={moment().subtract("M", monthLenght.value)}
                                        maxDate={dateEndRange}
                                        maxDateMessage="La fecha de Inicio no debe ser superior a la fecha actual"
                                        autoOk
                                        variant="inline"
                                        format="dd/MM/yyyy"
                                        margin="normal"
                                        id="date-start"
                                        label="Fecha de inicio"
                                        value={dateStart}
                                        onChange={handleDateStart}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        keyboardIcon={<CalendarTodayIcon style={{ color: "#2E2757" }} />}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item md={4} sm={12} xs={12}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                    <KeyboardDatePicker
                                        minDate={dateStart}
                                        maxDate={dateEnd}
                                        maxDateMessage="La fecha de fin no debe ser superior a la fecha actual"
                                        autoOk
                                        variant="inline"
                                        format="dd/MM/yyyy"
                                        margin="normal"
                                        id="date-end"
                                        label="Fecha de fin"
                                        value={dateEndRange}
                                        onChange={handleDateEnd}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        keyboardIcon={<CalendarTodayIcon style={{ color: "#2E2757" }} />}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item md={2} sm={6} xs={6} container direction="column" justifyContent="center" alignItems="center">
                                <Fab color="#FFFFFF" style={{ backgroundColor: '#b98919' }} aria-label="add" onClick={handleFindRange}>
                                    <Icon style={{ color: "#FFFFFF" }}>search</Icon>
                                </Fab>
                                {/* <Typography component="h2" variant="h6" gutterBottom style={{ color: "#000000", fontSize: "120%" }}>
                                    CONSULTAR
                                </Typography> */}
                            </Grid>
                            <Grid item md={2} sm={6} xs={6} container direction="column" justifyContent="center" alignItems="center">
                                <Fab color="#FFFFFF" style={{ backgroundColor: 'red' }} aria-label="add" onClick={() => history.push('/')}>
                                    <Icon style={{ color: "#FFFFFF" }}>close</Icon>
                                </Fab>
                                {/* <Typography component="h2" variant="h6" gutterBottom style={{ color: "#000000", fontSize: "120%" }}>
                                    CANCELAR
                                </Typography> */}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <br />
                <Grid container justify="center" spacing={3} alignItems="center">
                    <Grid item xs={12}>
                        {renderTableMovements()}
                    </Grid>
                </Grid>
            </div>
        );
    };

    return (

        <div>
            <Dashboard
                title="Dashboard"
                body={renderBody()}
                multiple={false}
            />
            <ModalTableReportDetails
                onCloseModal={handleCloseDialog}
                openModal={openModal}
                details={details}
            />
            <Footer />
        </div>
    );
};

MovementsContainer.propTypes = {
    secuencial: PropTypes.string.isRequired,
};
export default connect(null, { getCodes })(MovementsContainer);
